module.exports = __webpack_public_path__ + "img/phone.81e0974b.svg";